
import layerEvents from "../utils/layerEvents";
import Workmode from "../classes/Workmode";
import WorkmodeProject from "../classes/WorkmodeProject";


class WorkmodePower extends WorkmodeProject {


	constructor() {
		super();
		

	}
	areaLabel(){
		return 'Affected area';
	}
}

export default WorkmodePower;